import { get, put } from 'actions/api';
import * as actionTypes from 'constants/actionTypes';

export const getAppChangelog = () =>
  get(actionTypes.GET_APP_CHANGELOG, 'api', '/app-service/v2/changelog');

export const finishFeatureIntro = (id) =>
  put(actionTypes.UPDATE_APP_CHANGELOG, { id }, 'api', '/app-service/v2/changelog');
